import { BaseAction } from './BaseAction';
import { ModalName } from '../../shared/models/modal';

export enum ModalActions {
  OpenModal = '[Modal] Opening modal',
  CloseModal = '[Modal] Closing modal',
}

export class OpenModal implements BaseAction<ModalActions> {
  readonly type = ModalActions.OpenModal;

  constructor(public readonly name: ModalName, public readonly data: any) {}
}

export class CloseModal implements BaseAction<ModalActions> {
  readonly type = ModalActions.CloseModal;
}

export type ModalAction = OpenModal | CloseModal;